import { Injectable } from "@angular/core";
import { Socket } from 'ngx-socket-io';
import { CreateTicketEventDto, UpdateTicketEventDto } from "../dtos";
import { environment } from "src/app/config/environments/environment";
import { AuthUtil } from "src/app/data/utils/auth.utils";

@Injectable()
export class TicketsGatewayService extends Socket {
  constructor(
    private readonly authUtil: AuthUtil
  ) {
    super({
      url: `${environment.socketIoConfig.url}/tickets?token=${authUtil.getAccessToken()}`, 
      options: environment.socketIoConfig.options,
    });
  }

  /* EVENTS */
  connected = () => this.fromEvent<string>('connected');
  disconnected = () => this.fromEvent<string>('disconnected');

  /* TICKETS */
  createTicketRoom = (room: string) => this.emit('createTicketRoomEvent', room);

  ticketRoomCreated = () => this.fromEvent<string>('onTicketRoomCreatedEvent');
  
  joinTicketRoom = (room: string) => 
    this.emit('createTicketRoomEvent',room);

  receiveCreatedTicket = () =>
      this.fromEvent<CreateTicketEventDto>('onTicketCreatedEvent');

  receiveReOpenedTicket = () =>
    this.fromEvent<UpdateTicketEventDto>('onTicketReOpenEvent');

  receiveClosedTicket = () =>
    this.fromEvent<UpdateTicketEventDto>('onTicketClosedEvent');

  sendTicketClosureRequest = (message: UpdateTicketEventDto) =>
    this.emit('requestClosureEvent',message);
}